var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chrome',_vm._b({model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}},'chrome',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }